package ui.app.assign.detail.kindergarten.editor.page

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.staggeredgrid.LazyVerticalStaggeredGrid
import androidx.compose.foundation.lazy.staggeredgrid.StaggeredGridCells
import androidx.compose.foundation.lazy.staggeredgrid.items
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import api.ResourceOrientation
import api.ResourceType
import apps.App
import com.mohamedrejeb.richeditor.ui.material3.RichText
import compose.assets.Svg
import compose.assets.svg.DeleteEmpty
import compose.assets.svg.Plus
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_bottom__kindergarten_wireframe_tooltip
import tools.GlobalObjectShare
import tools.rememberRichTextState
import ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorScope
import ui.app.assign.detail.kindergarten.editor.NextAndSkip
import ui.resource.ResourceListingArgs
import ui.widget.LazyImage

@Composable
fun AppKindergartenEditorScope.KindergartenPage02Wireframe(nnvl: AppKindergartenEditorScope.Wrapper) {

    val imagePickerKey = "KindergartenPage02Wireframe"

    GlobalObjectShare.Consumer(imagePickerKey)

    val adapter = remember {
        nnvl.adapterCustomWireframe
    }

    fun openResourcePicker() {
        GlobalObjectShare.launchImagePicker(
            key = imagePickerKey,
            nav = nav,
            args = ResourceListingArgs(
                companyId = args.companyId,
                restrictionOrientation = ResourceOrientation.HORIZONTAL.mask,
                restrictionType = ResourceType.IMAGE.mask,
                restrictionCanIgnoreAspectRatio = true,
                excluded = adapter.state.joinToString { it.resource.state.toString() }
            )
        ) {
            it.firstOrNull()?.also {
                adapter.add(
                    index = 0,
                    newItem = App.Kindergarten.Photo(
                        resource = it.id,
                        names = mutableListOf(it.name)
                    )
                )
            }
        }
    }

    Box(Modifier.fillMaxSize()) {

        if (adapter.state.isEmpty()) {
            RichText(
                state = rememberRichTextState(Res.string.layer_bottom__kindergarten_wireframe_tooltip),
                modifier = Modifier.align(Alignment.TopCenter)
                    .padding(16.dp)
            )
        } else {
            LazyVerticalStaggeredGrid(
                columns = StaggeredGridCells.FixedSize(256.dp),
                modifier = Modifier.fillMaxSize(),
                verticalItemSpacing = 16.dp,
                horizontalArrangement = Arrangement.spacedBy(16.dp),
                contentPadding = PaddingValues(
                    start = 16.dp,
                    end = 16.dp,
                    top = 16.dp,
                    bottom = 32.dp
                )
            ) {
                items(adapter.state) {
                    WireframeItem(it) {
                        adapter.removeAll { entry -> entry.resource.state == it.resource.state }
                    }
                }
            }
        }

        NextAndSkip(Modifier.align(Alignment.BottomCenter).padding(16.dp))

        FloatingActionButton(
            onClick = { openResourcePicker() },
            modifier = Modifier.align(Alignment.BottomEnd).padding(16.dp)
        ) {
            Icon(Svg.Plus, null)
        }
    }
}

@Composable
private fun AppKindergartenEditorScope.WireframeItem(
    item: AppKindergartenEditorScope.WrapperPhotoEntry.Item,
    onDelete: () -> Unit
) {
    Card {
        Box {
            Column {
                LazyImage(
                    id = item.resource.state,
                    alphaBackground = false,
                    contentScale = ContentScale.Crop,
                    modifier = Modifier.fillMaxWidth()
                        .background(Color.White)
                        .aspectRatio(16F / 9F)
                )
                item.data.names.firstOrNull()?.also {
                    Text(
                        text = it,
                        style = MaterialTheme.typography.bodySmall,
                        overflow = TextOverflow.Ellipsis,
                        maxLines = 2,
                        modifier = Modifier.fillMaxSize()
                            .background(Color.Black)
                            .padding(4.dp)
                    )
                }
            }
            SmallFloatingActionButton(
                onClick = onDelete,
                modifier = Modifier.align(Alignment.TopEnd)
                    .padding(8.dp)
            ) {
                Icon(Svg.DeleteEmpty, null)
            }
        }
    }
}